"use client";

import { BSRSynchronized } from "./bsr/BSRSynchronized";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Synchronized as LegacySynchronized } from "./legacy/Synchronized";

export const Synchronized = createBSRExperimentIcon(
  LegacySynchronized,
  BSRSynchronized
);
